interface RegistrySortButtonProps {
  label: string;
  sort: string;
  ascending: string;
  descending: string;
  onChange: (sort: string) => void;
}

export function RegistrySortButton({
  label,
  sort,
  ascending,
  descending,
  onChange,
}: RegistrySortButtonProps) {
  const activeAscending = sort === ascending;
  const activeDescending = sort === descending;
  const active = activeAscending || activeDescending;
  const direction = activeDescending ? "descending" : activeAscending ? "ascending" : "none";
  return <button
    type="button"
    className={`registry-sort-button${active ? " registry-sort-button--active" : ""}`}
    aria-label={`${label}: сортировка ${direction === "ascending" ? "по возрастанию" : direction === "descending" ? "по убыванию" : "не выбрана"}`}
    title={`Сортировать: ${label}`}
    onClick={() => onChange(activeAscending ? descending : ascending)}
  >
    <span>{label}</span>
    <span className="registry-sort-button__icon" aria-hidden="true">
      {activeAscending ? "↑" : activeDescending ? "↓" : "↕"}
    </span>
  </button>;
}
